import { trackEvent } from "./mixpanel";

// Dashboard Analytics Helper
// Provides comprehensive tracking for dashboard and feature pages

export const trackPageView = (pageName, additionalProps = {}) => {
  trackEvent("page_viewed", {
    page: pageName,
    timestamp: new Date().toISOString(),
    ...additionalProps,
  });
};

export const trackDashboardInteraction = (
  action,
  section,
  additionalProps = {}
) => {
  trackEvent("dashboard_interaction", {
    action,
    section,
    timestamp: new Date().toISOString(),
    ...additionalProps,
  });
};

export const trackFeatureUsage = (feature, action, additionalProps = {}) => {
  trackEvent("feature_used", {
    feature,
    action,
    timestamp: new Date().toISOString(),
    ...additionalProps,
  });
};

export const trackModalInteraction = (
  modalType,
  action,
  additionalProps = {}
) => {
  trackEvent("modal_interaction", {
    modal_type: modalType,
    action,
    timestamp: new Date().toISOString(),
    ...additionalProps,
  });
};

export const trackFormSubmission = (
  formType,
  success,
  additionalProps = {}
) => {
  trackEvent("form_submitted", {
    form_type: formType,
    success,
    timestamp: new Date().toISOString(),
    ...additionalProps,
  });
};

export const trackNavigation = (fromPage, toPage, method = "click") => {
  trackEvent("navigation", {
    from_page: fromPage,
    to_page: toPage,
    method,
    timestamp: new Date().toISOString(),
  });
};

export const trackDataAction = (dataType, action, additionalProps = {}) => {
  trackEvent("data_action", {
    data_type: dataType,
    action,
    timestamp: new Date().toISOString(),
    ...additionalProps,
  });
};

// Specific tracking functions for common dashboard actions
export const trackCardClick = (cardType, section, additionalProps = {}) => {
  trackDashboardInteraction("card_clicked", section, {
    card_type: cardType,
    ...additionalProps,
  });
};

export const trackTabChange = (tabName, page, additionalProps = {}) => {
  trackDashboardInteraction("tab_changed", page, {
    tab: tabName,
    ...additionalProps,
  });
};

export const trackButtonClick = (buttonName, page, additionalProps = {}) => {
  trackDashboardInteraction("button_clicked", page, {
    button: buttonName,
    ...additionalProps,
  });
};

export const trackFilterChange = (
  filterType,
  value,
  page,
  additionalProps = {}
) => {
  trackDashboardInteraction("filter_changed", page, {
    filter_type: filterType,
    filter_value: value,
    ...additionalProps,
  });
};

export const trackSearch = (
  query,
  page,
  resultsCount = null,
  additionalProps = {}
) => {
  trackDashboardInteraction("search_performed", page, {
    query,
    results_count: resultsCount,
    ...additionalProps,
  });
};

export const trackEmptyStateAction = (action, page, additionalProps = {}) => {
  trackDashboardInteraction("empty_state_action", page, {
    action,
    ...additionalProps,
  });
};

// User engagement tracking
export const trackTimeOnPage = (pageName, timeSpent) => {
  trackEvent("time_on_page", {
    page: pageName,
    time_spent_seconds: timeSpent,
    timestamp: new Date().toISOString(),
  });
};

export const trackScrollDepth = (pageName, depth) => {
  trackEvent("scroll_depth", {
    page: pageName,
    scroll_depth_percent: depth,
    timestamp: new Date().toISOString(),
  });
};

// Error tracking
export const trackError = (
  errorType,
  errorMessage,
  page,
  additionalProps = {}
) => {
  trackEvent("error_occurred", {
    error_type: errorType,
    error_message: errorMessage,
    page,
    timestamp: new Date().toISOString(),
    ...additionalProps,
  });
};

// Performance tracking
export const trackPerformance = (metric, value, page, additionalProps = {}) => {
  trackEvent("performance_metric", {
    metric,
    value,
    page,
    timestamp: new Date().toISOString(),
    ...additionalProps,
  });
};
